import '@angular/localize/init';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import config from './assets/config.json';

bootstrapApplication(AppComponent, appConfig).catch(() => {});
addGtagScript();
// Function to add the gtag script dynamically in <head> and <body>
function addGtagScript() {
  const gtagConfig = { ...config };
  if (!gtagConfig || !gtagConfig.GTAG_ID) {
    return;
  }

  const inlineScript = document.createElement('script');
  inlineScript.appendChild(
    document.createTextNode(
      `
      (function(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
    });
    var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src =
        'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', '${gtagConfig.GTAG_ID}');
    `,
    ),
  );
  document.head.prepend(inlineScript);
  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');

  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtagConfig.GTAG_ID}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';

  noscript.appendChild(iframe);
  document.body.prepend(noscript);
}
